var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_367_448",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.95117,
    y: 2.5,
    width: 18,
    height: 18,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_367_448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9512 12C21.9512 12 18.5762 5.8125 12.9512 5.8125C7.32617 5.8125 3.95117 12 3.95117 12C3.95117 12 7.32617 18.1875 12.9512 18.1875C18.5762 18.1875 21.9512 12 21.9512 12ZM5.27085 12C5.81481 12.8267 6.44045 13.5967 7.13835 14.2984C8.58622 15.7485 10.5662 17.0625 12.9512 17.0625C15.3362 17.0625 17.3151 15.7485 18.7652 14.2984C19.4631 13.5967 20.0888 12.8267 20.6327 12C20.0888 11.1733 19.4631 10.4033 18.7652 9.70162C17.3151 8.2515 15.3351 6.9375 12.9512 6.9375C10.5662 6.9375 8.58735 8.2515 7.13722 9.70163C6.43932 10.4033 5.81367 11.1733 5.26971 12L5.27085 12Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9512 9.1875C11.3979 9.1875 10.1387 10.4467 10.1387 12C10.1387 13.5533 11.3979 14.8125 12.9512 14.8125C14.5045 14.8125 15.7637 13.5533 15.7637 12C15.7637 10.4467 14.5045 9.18751 12.9512 9.1875H12.9512ZM9.01367 12C9.01367 10.5933 9.76415 9.29339 10.9824 8.59003C12.2007 7.88666 13.7017 7.88666 14.9199 8.59002C16.1382 9.29339 16.8887 10.5933 16.8887 12C16.8887 13.4067 16.1382 14.7066 14.9199 15.41C13.7017 16.1133 12.2007 16.1133 10.9824 15.41C9.76416 14.7066 9.01367 13.4067 9.01367 12V12Z",
    fill: "#BEBEBE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0743b439f50dc7bddda8c41bc7caf83e.svg";
export { ForwardRef as ReactComponent };